import React, { useState, useEffect } from 'react';
const cachedScripts = [];
export function useScriptLoader(scriptUrl: string, attributes?: Record<string, string>) {
  const [scriptLoaded, setScriptLoaded] = useState(cachedScripts.includes(scriptUrl));
  const [scriptLoadingFailed, setScriptLoadingFailed] = useState(false);
  useEffect(() => {
    if (scriptLoaded) {
      return;
    }

    const script = document.createElement('script');
    script.src = scriptUrl;
    script.async = true;

    if (attributes) {
      Object.entries(attributes).forEach(([key, value]) => {
        if (typeof value === 'string') {
          script.setAttribute(key, value);
        }
      });
    }

    new Promise((resolve, reject) => {
      script.addEventListener('load', () => resolve(scriptUrl));
      script.addEventListener('error', (e) => reject(e));
    })
      .then(() => {
        cachedScripts.push(scriptUrl);
        setScriptLoaded(true);
      })
      .catch(() => {
        script.remove();
        setScriptLoadingFailed(true);
      });
    document.body.appendChild(script);
  }, [scriptUrl, attributes, scriptLoaded]);
  return {
    scriptLoaded,
    scriptLoadingFailed,
  };
}
